<template>
  <div v-if="autocharged" data-testid="membership-tier-autocharge" class="mt-1">
    <Chip text="Autocharged" variant="required" />
    <div v-if="description" data-testid="autocharge-description" class="mt-1 text-sm text-gray-brand-700">
      {{ description }}
    </div>
  </div>
</template>

<script>
import Chip from '@/components/Molecules/Chip'
import mapRelationship from '../../utils/mapRelationship'

export default {
  name: 'MembershipTierAutocharge',
  components: { Chip },
  props: {
    tier: { type: Object, default: null }
  },
  computed: {
    summary() {
      return mapRelationship(this.$store.state, this.tier?.relationships?.autocharge_summary?.data)
    },
    autocharged() {
      return this.summary?.attributes?.autocharged === true
    },
    description() {
      return this.summary?.attributes?.description
    }
  }
}
</script>
